const Divider = () => (
  <div className=" col-span-12" aria-hidden="true">
    <div className="py-5">
      <div className="border-t border-gray-200" />
    </div>
  </div>
)

export default Divider
